<div *ngIf="evadiForm">
    <div class="col-sm-12 coldx">
        <form [formGroup]="evadiForm" (ngSubmit)="save();">
            <div class="row">
                <div datePickerInput class="col-sm-6" [labelInput]="'Data evasione'" [mandatory]="true"
                    formControlName="dataEvasione" [(ngModel)]="request.dataEvasione" [control]="evadiForm.controls['dataEvasione']"></div>
                <div comboModInput class="col-sm-6" [labelInput]="'Motivo evasione'" [mandatory]="false"
                    formControlName="motivoEvasione" [objectReference]="request.motivoEvasione"
                    [control]="evadiForm.controls['motivoEvasione']"
                    [ngModel]="request.motivoEvasione"
                    (onReturn)="request.motivoEvasione = $event"
                    [optionsCombo] ="motiviOptions"></div>
            </div>
            <div class="row">
                <p class="mandatory col-sm-12">
                    <em>* Campi obbligatori</em>
                </p>
            </div>
    
            <div class="row">
                <p class="col-sm-3 col-xs-6">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="createForm();">Reset</button>
                </p>
                <p submitButton [disabled]="!evadiForm.valid"
                    class="col-sm-3 col-xs-6 col-sm-offset-6"
                    [labelButton]="'Salva'"></p>
            
            </div>
        </form>

    </div>
</div>
 
